import type { ServerMessages } from '@/i18n/messages/en/errors/index.ts'

/** What the people domain's refusals say, in English (the source of truth AND the type). */
export const people: Pick<
  ServerMessages,
  | 'people.no_account_for_email'
  | 'people.cannot_deactivate_yourself'
  | 'people.already_deactivated'
  | 'people.already_active'
  | 'people.confirm_name_to_deactivate'
  | 'people.directory_requires_role'
> = {
  'people.no_account_for_email': () =>
    'Nobody with that email address has an account here yet. Ask them to sign in once first.',

  'people.cannot_deactivate_yourself': () =>
    'You cannot deactivate your own account. Ask another administrator to do it.',
  'people.already_deactivated': () => 'That account is already deactivated.',
  'people.already_active': () => 'That account is already active.',
  'people.confirm_name_to_deactivate': ({ name }) => `Type ${name} to confirm that this account should be deactivated.`,

  // "auditor" and "operator" are role identifiers, not words: they are what the roles are
  // called on the wire and in the audit trail, and they stay in English (D-17).
  'people.directory_requires_role': () => 'Reading the directory of people requires the “auditor” or “operator” role.'
}
